import logger from '../utils/logger';
import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { useShop } from '../context/ShopContext';

export const useBaristaShopLoader = () => {
  const { isAuthenticated, loading: authLoading, user } = useAuth();
  const { shop, fetchShop, loading: shopLoading, initialized } = useShop();
  const hasAttemptedFetch = useRef(false);

  useEffect(() => {
  logger.debug('useBaristaShopLoader: Effect triggered', {
      isAuthenticated,
      authLoading,
      userRole: user?.role,
      hasShop: !!shop,
      shopLoading,
      hasAttemptedFetch: hasAttemptedFetch.current,
      initialized
    });
    
    // Only fetch shop for baristas when authentication is complete
    if (isAuthenticated && !authLoading && user?.role === 'BARISTA' && !shop && !shopLoading && !hasAttemptedFetch.current && initialized) {
  logger.debug('useBaristaShopLoader: Fetching shop for barista');
      hasAttemptedFetch.current = true;
      fetchShop().catch(error => {
  logger.debug('useBaristaShopLoader: No shop found for barista');
  logger.debug('useBaristaShopLoader: Error details:', error.response?.status, error.response?.data);
      });
    }
  }, [isAuthenticated, authLoading, user, shop, shopLoading, initialized, fetchShop]);

  return {
    shop,
    loading: authLoading || shopLoading,
    hasShop: !!shop
  };
}; 